module.exports = __webpack_public_path__ + "img/paragraph-left.b42833e3.svg";